import axios from "axios";
import { API_PROXY } from "../../services/apiUrls";

const options = { timeout: 10000 };
export async function fetchTermsDefinition(nameseo) {
  const response = await axios.get(
    `${API_PROXY}getTermsForm/${encodeURIComponent(nameseo)}?communicationConsent=1`,
    options,
  );
  if (response.status === 204) return null;
  if (
    response.status !== 200 ||
    response.data?.status !== "success" ||
    typeof response.data?.text !== "string" ||
    !response.data.text.trim()
  ) {
    throw new Error("Invalid terms document response");
  }
  return response.data;
}

export function unwrapConsentResponse(raw) {
  let result = raw;
  for (let depth = 0; depth < 5; depth++) {
    if (typeof result === "string") {
      try {
        result = JSON.parse(result);
      } catch (_) {
        throw new Error("Invalid consent response");
      }
    } else if (
      result &&
      Object.prototype.hasOwnProperty.call(result, "response")
    ) {
      result = result.response;
    } else break;
  }
  if (!result || typeof result !== "object" || Array.isArray(result))
    throw new Error("Invalid consent response");
  return result;
}

export async function fetchConsent({ radioid, token }) {
  const response = await axios.get(
    `${API_PROXY}getUserExtra?${new URLSearchParams({ radioid, token })}`,
    options,
  );
  const data = unwrapConsentResponse(response.data);
  const hasExtra = [data, data.data, data.data?.data].some(
    (value) => value && Object.prototype.hasOwnProperty.call(value, "extra"),
  );
  // Sonicola returns success/data:null when this account has no record for
  // the radio yet. This is a valid negative lookup, not a transport failure.
  const hasNoRecord = data.status === "success" && data.data === null;
  if (
    response.status !== 200 ||
    (data.status && data.status !== "success") ||
    (!hasExtra && !hasNoRecord)
  ) {
    throw new Error("Could not retrieve user terms acceptance");
  }
  return data;
}

export async function persistConsent({ radioid, token, extra }) {
  const response = await axios.get(
    `${API_PROXY}addUserExtra?${new URLSearchParams({ radioid, token, extra })}`,
    options,
  );
  const data = unwrapConsentResponse(response.data);
  if (response.status !== 200 || data.status !== "success")
    throw new Error("Could not persist user terms acceptance");
  // Return only the upstream response. PHP's outer params contain the auth token.
  return data;
}
